<template>
  <div class="experience-section">
    <h2 class="text-2xl font-bold mb-4" :style="{ color: themeColor, borderBottom: `2px solid ${themeColor}`, paddingBottom: '0.5rem' }">
      Experience
    </h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="mb-6">
      <div class="flex justify-between items-start mb-2">
        <div>
          <h3 class="text-xl font-semibold">{{ item.title || 'Job Title' }}</h3>
          <p class="text-lg text-gray-700">{{ item.company || 'Company Name' }}</p>
        </div>
        <div class="text-right text-sm text-gray-600">
          <p>{{ item.startDate || 'Start' }} - {{ item.endDate || 'End' }}</p>
          <p v-if="item.location">{{ item.location }}</p>
        </div>
      </div>
      <ul class="list-disc list-inside text-gray-700 ml-4">
        <li v-for="(desc, idx) in item.description" :key="idx" v-if="desc">
          {{ desc }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#17803d'
    }
  }
}
</script>

